/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button, IconButton, Modal, TextareaAutosize, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Close from '@material-ui/icons/Close';
import Favorite from '@material-ui/icons/Favorite';
import FavoriteBorderOutlined from '@material-ui/icons/FavoriteBorderOutlined';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { v4 as uuidv4 } from 'uuid';
import { useVaultService } from '../../hooks/useVaultService';

const useStyles = makeStyles(() => ({
  root: {
    width: window.innerWidth > 560 ? '50%' : '100%',
    minHeight: window.innerWidth > 560 ? 0 : '100%',
    maxWidth: 527,
    minWidth: 317,
    background: '#fff',
    margin: '0 auto',
    borderRadius: window.innerWidth > 560 ? 10 : 0,
    boxShadow: '0px 1px 7px rgba(0, 0, 0, 0.15)',
    padding: 25,
  },
  modal: {
    overflow: 'auto',
    paddingTop: window.innerWidth > 560 ? '10vh' : 0,
    paddingBottom: window.innerWidth > 560 ? '10vh' : 0,
  },
  close: {
    color: '#C1C4C9',
    marginTop: 3,
    width: '100%',
    cursor: 'pointer',
  },
  title: {
    color: '#A6AAB0',
    marginTop: -20,
    fontSize: 18,
    marginLeft: 40,
    marginRight: 40,
    textAlign: 'center',
  },
  description1: {
    color: '#2E3542',
    marginTop: 2,
    fontSize: 14,
    marginLeft: 40,
    marginRight: 40,
    textAlign: 'center',
  },
  fieldsWrap: {
    marginTop: 30,
    paddingLeft: window.innerWidth > 560 ? 40 : 0,
    paddingRight: window.innerWidth > 560 ? 40 : 0,
    width: '100%',
    flexDirection: 'column',
  },
  input: {
    width: '100%',
  },
  textarea: {
    width: '100%',
    borderRadius: 10,
    background: '#F4F8FC',
    color: '#2E3542',
    border: '1px solid #F4F8FC',
    padding: '17px 22px',
    fontSize: 16,
    fontFamily: 'Roboto',
    '&:focus': {
      outline: 'none',
    },
    '&:placeholder': {
      outline: 'none',
      color: '#A6AAB0',
    },
  },
  favBtn: {},
  favText: {
    color: '#A6AAB0',
    fontSize: 14,
    marginLeft: 3,
  },
}));

const INITIAL_STATE = {
  name: '',
  surname: '',
  parton: '',
  phone: '',
  email: '',
  url: '',
  messenger: '',
  fav: false,
  desc: '',
};

const CreateContacts = (props) => {
  const classes = useStyles();
  const vaultService = useVaultService();
  const { t } = useTranslation();
  const [isLoading] = useState(false);
  const [state, setState] = useState(INITIAL_STATE);
  const { currentVault, updateCurrentVault } = vaultService;
  const { onClose, editRowId } = props;

  const onChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.value });
  };

  const toogleFavorite = () => {
    setState({ ...state, fav: !state.fav });
  };

  const init = () => {
    if (editRowId) {
      const currentRecContact = currentVault.rec_contact.find((item) => item.id === editRowId);
      if (currentRecContact) {
        setState({ ...currentRecContact });
      }
    }
  };

  const onSubmit = () => {
    const data = {
      ...state,
      id: uuidv4(),
      cre: new Date().getTime(),
      upd: new Date().getTime(),
    };
    if (editRowId) {
      const currentRecContact = currentVault.rec_contact.find((item) => item.id === editRowId);
      currentVault.rec_contact = currentVault.rec_contact.filter((item) => item.id !== editRowId);
      currentVault.rec_contact.push({
        ...data,
        cre: currentRecContact ? currentRecContact.cre : new Date().getTime(),
        id: editRowId,
      });
    } else {
      currentVault.rec_contact.push(data);
    }
    updateCurrentVault();
    onClose();
  };

  useEffect(() => {
    init();
  }, []);

  const isInvalid = !(state.name && state.surname && (state.phone || state.email));

  return (
    <Modal open={true} className={classes.modal} onClose={() => onClose()}>
      <Box
        className={classes.root}
        display="flex"
        flexDirection="column"
        justifyContent="flex-start"
        alignItems="center"
      >
        <Box
          onClick={() => onClose()}
          className={classes.close}
          display="flex"
          flexDirection="row"
          justifyContent="flex-end"
          alignItems="center"
        >
          <Close />
        </Box>
        <Box
          className={classes.title}
          display="flex"
          flexDirection="columm"
          justifyContent="center"
          alignItems="center"
        >
          {editRowId ? 'EDIT' : 'NEW BANK CARD'}
        </Box>
        <Box
          className={classes.description1}
          display="flex"
          flexDirection="columm"
          justifyContent="center"
          alignItems="center"
        >
          {t('translation:commonPages:contacts')}
        </Box>

        <Box className={classes.fieldsWrap} display="flex" justifyContent="flex-start" alignItems="center">
          <TextField
            type="text"
            id="name"
            name="name"
            value={state.name}
            inputProps={{
              maxLength: 50,
            }}
            color="primary"
            onChange={onChange}
            placeholder={t('translation:commonPages:firstName')}
            label={t('translation:commonPages:firstName')}
            required
            fullWidth
            InputProps={{
              classes: {
                input: classes.input,
              },
            }}
            style={{ marginBottom: 24 }}
          />

          <TextField
            type="text"
            id="surname"
            name="surname"
            value={state.surname}
            inputProps={{
              maxLength: 50,
            }}
            color="primary"
            onChange={onChange}
            placeholder={t('translation:commonPages:lastName')}
            label={t('translation:commonPages:lastName')}
            required
            fullWidth
            InputProps={{
              classes: {
                input: classes.input,
              },
            }}
            style={{ marginBottom: 24 }}
          />

          <TextField
            type="text"
            id="patron"
            name="patron"
            value={state.patron}
            inputProps={{
              maxLength: 50,
            }}
            color="primary"
            onChange={onChange}
            placeholder={t('translation:commonPages:patronymic')}
            label={t('translation:commonPages:patronymic')}
            fullWidth
            InputProps={{
              classes: {
                input: classes.input,
              },
            }}
            style={{ marginBottom: 24 }}
          />

          <TextField
            type="text"
            id="email"
            name="email"
            value={state.email}
            inputProps={{
              maxLength: 64,
            }}
            color="primary"
            onChange={onChange}
            placeholder={t('translation:commonPages:email')}
            label={t('translation:commonPages:email')}
            fullWidth
            InputProps={{
              classes: {
                input: classes.input,
              },
            }}
            style={{ marginBottom: 24 }}
          />

          <TextField
            type="text"
            id="phone"
            name="phone"
            value={state.phone}
            inputProps={{
              maxLength: 30,
            }}
            color="primary"
            onChange={onChange}
            placeholder={t('translation:commonPages:phone')}
            label={t('translation:commonPages:phone')}
            fullWidth
            InputProps={{
              classes: {
                input: classes.input,
              },
            }}
            style={{ marginBottom: 24 }}
          />

          <TextField
            type="text"
            id="url"
            name="url"
            value={state.url}
            inputProps={{
              maxLength: 30,
            }}
            color="primary"
            onChange={onChange}
            placeholder={t('translation:commonPages:webSite')}
            label={t('translation:commonPages:webSite')}
            fullWidth
            InputProps={{
              classes: {
                input: classes.input,
              },
            }}
            style={{ marginBottom: 24 }}
          />

          <TextField
            type="text"
            id="messenger"
            name="messenger"
            value={state.messenger}
            inputProps={{
              maxLength: 64,
            }}
            color="primary"
            onChange={onChange}
            placeholder={t('translation:commonPages:messenger')}
            label={t('translation:commonPages:messenger')}
            fullWidth
            InputProps={{
              classes: {
                input: classes.input,
              },
            }}
            style={{ marginBottom: 24 }}
          />

          <TextareaAutosize
            aria-label="minimum height"
            rowsMin={2}
            maxLength={264}
            placeholder={t('translation:commonPages:desc')}
            className={classes.textarea}
            id="desc"
            name="desc"
            value={state.desc}
            onChange={onChange}
          />
          <Box
            display="flex"
            mt={5}
            flexDirection="row"
            alignItems="center"
            justifyContent="flex-start"
            style={{ width: '100%', marginLeft: -20 }}
          >
            <IconButton
              className={classes.favBtn}
              aria-label="view list"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              style={{ color: state.fav ? '#E41139' : '#A6AAB0' }}
              onClick={toogleFavorite}
            >
              {state.fav ? <Favorite /> : <FavoriteBorderOutlined />}
            </IconButton>
            <span className={classes.favText}>{t('translation:commonPages:addFav')}</span>
          </Box>
        </Box>
        <Box
          className={classes.passwordField}
          display="flex"
          flexDirection="columm"
          justifyContent="center"
          alignItems="center"
          mt={7}
          mb={5}
        >
          <Button style={{ marginRight: 20 }} onClick={() => onClose()} variant="outlined" color="primary">
            {t('translation:commonPages:cancel')}
          </Button>
          <Button variant="contained" disabled={isInvalid || isLoading} onClick={() => onSubmit()} color="primary">
            {t('translation:commonPages:save')}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default CreateContacts;
